import { CrudPage } from '@restavo/crud';
import React from 'react';
import { useMenuItemVariantsPage } from 'src/features/menuItemVariants';

const MenuItemVariantsSettings = React.memo(() => {
  const { page, imagesViewer } = useMenuItemVariantsPage();
  return (
    <>
      <CrudPage {...page} />
      {imagesViewer}
    </>
  );
});

export default MenuItemVariantsSettings;
